import { IMAGE_GENERATION_TOOL_NAME } from "../constants/chat";
import type { IMessage } from "../types/chat";

// NOTE: A turn whose image came from the `generateImage` TOOL is not over when
// the model stops talking. The image is uploaded and its row persisted while the
// tool result is consumed, but nothing is emitted to the clients at that moment:
// AI_GENERATED files deliberately skip the `toolFile` event (NSAI-4262) because
// they render inline from the message's own files, so the picture only arrives
// with the final `messageUpdated`, after the server has re-read it from S3 and
// base64-encoded it. `streamFinish` lands at the start of that window.
//
// Treating `streamFinish` as terminal is what made a card go quiet — or, when
// the model wrote no caption at all, show "Connection was lost while generating
// the response" with a Resend button — for the seconds until the image landed,
// after which the picture silently replaced the error. In multi-model each card
// crosses that window on its own schedule, so the row never looked coherent.
//
// `done`, `streamError` and a delivered file all close the window; anything that
// ends the turn for real still ends it.
export const checkIsAwaitingGeneratedImage = (message: IMessage): boolean =>
  message.tool?.name === IMAGE_GENERATION_TOOL_NAME &&
  message.done !== true &&
  !message.streamError &&
  (message.files?.length ?? 0) === 0;
